module.exports = __webpack_public_path__ + "media/images/logo-unipos-4b3f3409c4edbfb06142b6d9bae14df0.svg";